import { Link } from 'react-router-dom'
import { IconPlus, IconFileText } from '@tabler/icons-react'

const quickActions = [
  {
    label: 'Nova Reserva',
    icon: IconPlus,
    to: '/reserves',
    colorClass: 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700',
    description: 'Crear una nova reserva'
  },
  {
    label: 'Nou Client',
    icon: IconPlus,
    to: '/clients',
    colorClass: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
    description: 'Afegir un nou client'
  },
  {
    label: 'Nou Viatger',
    icon: IconPlus,
    to: '/viatgers',
    colorClass: 'bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700',
    description: 'Registrar un nou viatger'
  },
  {
    label: 'Generar TXT Mossos',
    icon: IconFileText,
    to: '/mossos',
    colorClass: 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700',
    description: 'Generar fitxer per Mossos',
    disabled: true
  }
]

export default function QuickActions() {
  return (
    <div className="bg-white/80 backdrop-blur-xl border border-gray-200 rounded-2xl p-6 shadow-lg">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Accions Ràpides</h2>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions.map((action) => {
          const Icon = action.icon
          
          if (action.disabled) {
            return (
              <div
                key={action.label}
                className="relative p-4 rounded-xl bg-gray-100 border-2 border-gray-200 opacity-50 cursor-not-allowed"
              >
                <div className="flex flex-col items-center text-center space-y-2">
                  <div className="p-3 rounded-full bg-gray-200">
                    <Icon className="w-6 h-6 text-gray-400" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-500">{action.label}</p>
                    <p className="text-xs text-gray-400 mt-1">{action.description}</p>
                  </div>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="text-xs bg-gray-200 text-gray-500 px-2 py-1 rounded">
                    Pròximament
                  </span>
                </div>
              </div>
            )
          }
          
          return (
            <Link
              key={action.label}
              to={action.to}
              className="group"
            >
              <div className={`${action.colorClass} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105`}>
                <div className="flex flex-col items-center text-center space-y-2">
                  <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold text-white">{action.label}</p>
                    <p className="text-xs text-white/80 mt-1">{action.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
